'use strict';

var trimSlashes = require('./trimSlashes.js');

/**
 * Parses the given href and returns an object containing information about it.
 * If the href is null or empty, it returns an object with external set to false and href set to null.
 * If the href is "__home__", it returns an object with external set to false and href set to "/".
 * Otherwise, it parses the href using the URL class and determines if it is an external link or not.
 * If it is an external link, it returns the full URL. Otherwise, it returns the pathname, search, and hash components of the URL.
 *
 * @param maybeHref - The href to parse.
 * @returns An object containing information about the parsed href.
 */ function parseHref(maybeHref) {
    if (!maybeHref || !maybeHref.length) return {
        external: false,
        href: null
    };
    // Special case from CraftCMS
    maybeHref = maybeHref === '__home__' ? '/' : trimSlashes(maybeHref);
    const WEBSITE_HOST = 'example.com';
    const { href: fullUrl, host, pathname, search, hash } = new URL(maybeHref, `https://${WEBSITE_HOST}`);
    const external = host !== WEBSITE_HOST;
    const href = external ? fullUrl : `${pathname}${search}${hash}`;
    return {
        external,
        href
    };
}

module.exports = parseHref;
